// Survey lifecycle drawer: renders control buttons and state header.

import React from "react";
import { Button } from "@material-tailwind/react";
import AppDrawer from "components/ui/drawer";
import {
    isCopyableUrl,
    isPausable,
    isPreLaunchable,
    isPreviewable,
    isResumable,
    isRestartable,
} from "../lifecycle-visibility";
import { displayStartDateTime } from "../date-helpers";

export default function LifecycleDrawer({
    open,
    onClose,
    survey,
    isValid,
    values,
    onCheckLaunch,
    onPreview,
    onLaunch,
    onCopyUrl,
    onPause,
    onFinish,
    onResume,
    onRestart,
}) {
    return (
        <AppDrawer open={open} onClose={onClose} title="Survey Controls">
            {/*Survey Info*/}
            <div className="my-2">
                <div>
                    <span className=" font-display sm:text-lg text-sm">
                        {`Survey state: ${survey.state}`}
                    </span>
                </div>
                {!!(survey.state === "published") && (
                    <div className="mt-4">
                        <span className="font-display sm:text-lg text-sm">
                            {`Survey will be live on: ${displayStartDateTime(
                                survey.start_date,
                            )}`}
                        </span>
                    </div>
                )}
            </div>
            {/*Control Buttons*/}
            <div className="flex flex-col gap-3">
                {!!(
                    survey.state === "draft" ||
                    survey.state === "published" ||
                    survey.state === "paused"
                ) && (
                    <Button
                        className="btn btn--primary"
                        type="button"
                        variant="filled"
                        onClick={() => onCheckLaunch(values)}
                        disabled={!isPreLaunchable(survey.state)}
                    >
                        Pre-Launch Check
                    </Button>
                )}

                {!!(isPreviewable(survey.state)) && (
                    <>
                        <Button
                            className="btn btn--primary"
                            type="button"
                            disabled={
                                !(survey.state === "draft") || !isValid
                            }
                            onClick={() => onPreview(values)}
                            variant="filled"
                        >
                            Preview
                        </Button>
                        <Button
                            className="btn btn--primary"
                            type="button"
                            variant="filled"
                            onClick={() => onLaunch(values)}
                            disabled={!isPreviewable(survey.state)}
                        >
                            Launch
                        </Button>
                    </>
                )}
                {!!(isCopyableUrl(survey.state)) && (
                    <Button
                        className="btn btn--secondary"
                        type="button"
                        variant="filled"
                        onClick={onCopyUrl}
                    >
                        Copy URL
                    </Button>
                )}
                {!!(isPausable(survey.state)) && (
                    <>
                        <Button
                            className="btn btn--secondary"
                            type="button"
                            color={isValid ? "blue-gray" : "gray"}
                            variant="filled"
                            onClick={onPause}
                            disabled={!isPausable(survey.state)}
                        >
                            Pause Survey
                        </Button>
                        <Button
                            className="btn btn--secondary"
                            type="button"
                            color={isValid ? "gray" : "blue-gray"}
                            variant="filled"
                            onClick={onFinish}
                            disabled={!(survey.state === "active")}
                        >
                            Finish Survey
                        </Button>
                    </>
                )}

                {!!(isResumable(survey.state)) && (
                    <>
                        <Button
                            className="btn btn--secondary"
                            type="button"
                            color={isValid ? "blue-gray" : "gray"}
                            variant="filled"
                            onClick={onResume}
                            disabled={!isResumable(survey.state)}
                        >
                            Resume
                        </Button>
                    </>
                )}
                {!!(isRestartable(survey.state)) && (
                    <Button
                        className="btn btn--secondary"
                        type="button"
                        color={isValid ? "blue-gray" : "gray"}
                        variant="filled"
                        onClick={onRestart}
                    >
                        Restart
                    </Button>
                )}
            </div>
        </AppDrawer>
    );
}
